import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/edit_pencil.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e222a2d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "providers-list-bottom" }
const _hoisted_2 = { class: "providers-list-bottom-text" }
const _hoisted_3 = { style: {"margin-right":"10px"} }
const _hoisted_4 = { class: "term-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1),
    _createElementVNode("span", {
      class: "providers-list-bottom-amount",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAmountChange && _ctx.handleAmountChange(...args)))
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$n(_ctx.amount, "currency", _ctx.locale.value)) + " ", 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.termLabel), 1)
      ]),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Change amount",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAmountChange && _ctx.handleAmountChange(...args)))
      })
    ])
  ]))
}